import { useToastContext } from '@contexts/ToastContext';
import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import ToastItem from './ToastItem';

const styles = StyleSheet.create({
  toastWithMargin: {
    marginBottom: 8,
  },
  toastWithoutMargin: {
    marginBottom: 0,
  },
  toastWrapper: {
    width: '100%',
  },
});

const ToastContainer: React.FC = () => {
  const { toasts } = useToastContext();

  const getContainerStyle = (placement: string) => {
    const baseStyle = {
      position: 'absolute' as const,
      zIndex: 9999,
    };

    switch (placement) {
      case 'top':
        return {
          ...baseStyle,
          top: Platform.OS === 'web' ? 20 : 50,
          left: 0,
          right: 0,
          alignItems: 'center' as const,
        };
      case 'top-left':
        return {
          ...baseStyle,
          top: Platform.OS === 'web' ? 20 : 50,
          left: 0,
          alignItems: 'flex-start' as const,
        };
      case 'top-right':
        return {
          ...baseStyle,
          top: Platform.OS === 'web' ? 20 : 50,
          right: 0,
          alignItems: 'flex-end' as const,
        };
      case 'bottom':
        return {
          ...baseStyle,
          bottom: Platform.OS === 'web' ? 20 : 50,
          left: 0,
          right: 0,
          alignItems: 'center' as const,
        };
      case 'bottom-left':
        return {
          ...baseStyle,
          bottom: Platform.OS === 'web' ? 20 : 50,
          left: 0,
          alignItems: 'flex-start' as const,
        };
      case 'bottom-right':
        return {
          ...baseStyle,
          bottom: Platform.OS === 'web' ? 20 : 50,
          right: 0,
          alignItems: 'flex-end' as const,
        };
      default:
        return {
          ...baseStyle,
          top: Platform.OS === 'web' ? 20 : 50,
          left: 0,
          right: 0,
          alignItems: 'center' as const,
        };
    }
  };

  // Group toasts by placement
  const toastsByPlacement = toasts.reduce((acc, toast) => {
    const placement = toast.placement || 'top';
    if (!acc[placement]) {
      acc[placement] = [];
    }
    acc[placement].push(toast);
    return acc;
  }, {} as Record<string, typeof toasts>);

  return (
    <>
      {Object.entries(toastsByPlacement).map(([placement, placementToasts]) => (
        <View key={placement} style={getContainerStyle(placement)}>
          {placementToasts.map((toast, index) => (
            <View
              key={toast.id}
              style={[
                styles.toastWrapper,
                index < placementToasts.length - 1 ? styles.toastWithMargin : styles.toastWithoutMargin,
              ]}>
              <ToastItem toast={toast} />
            </View>
          ))}
        </View>
      ))}
    </>
  );
};

export default ToastContainer;
